// extracted by css-extract-rspack-plugin
export default {"cls1":"MarketingPageLayout-cls1_-6o","cls2":"MarketingPageLayout-cls2_IqL MarketingPageLayout-cls1_-6o"};